import axios from "axios";
export default {
    getLevels: (entityId, entityType) => axios.post("/AccessLevels/GetLevels", { EntityId: entityId, EntityType: entityType })
};
